import Alert from 'react-bootstrap/Alert';

const AlertMessage = ({ message, variant = 'danger' }) => {
  if (!message) return null;
  return (
    <Alert variant={variant} className='py-2'>
      {message}
    </Alert>
  );
};

export default AlertMessage;
